import ResetMap from 'components/Icons/ResetMap';
import React from 'react';

type Props = {
  onClick: () => void;
};

const DirectionalButton: React.FC<Props> = ({ onClick }: Props) => {
  return (
    <button
      style={{
        backgroundColor: 'white',
        borderWidth: 0,
        cursor: 'pointer',
        gridColumn: 2,
        gridRow: 2,
        outline: 'none',
      }}
      onClick={onClick}
    >
      <ResetMap />
    </button>
  );
};

export default DirectionalButton;
